<template>
<div :class="type === 'login' ? 'with-pwd' : 'bind-with-pwd'">
  <template v-if="type === 'login' && showLogo">
    <img class="logo-img"  :src="$cvWebpFn('https://img.kilimall.com/c/h5/logo_icon_164_x3.png')" alt="">
  </template>

  <van-form @submit="onSubmit" class="with-password-form">
    <van-field
      v-model.trim="loginForm.account"
      name="account"
      placeholder="Phone No. or Email"
      :rules="[{ required: true, message: 'Please input account' }]"
    />
    <van-field
      v-model.trim="loginForm.password"
      :type="inputType"
      name="password"
      placeholder="Password"
      :rules="[{ required: true, message: 'Please input password' }]"
    >
      <template v-slot:right-icon>
        <div class="password-right">
          <van-icon name="eye-o" v-if="inputType !== 'password'" @click="handleShowPassword" />
          <van-icon name="closed-eye" v-else @click="handleShowPassword" />
          <span v-if="type === 'login'" class="password-divider" />
          <span v-if="type === 'login'" class="forgot-link" @click.stop="handleToForgotPassword">Forgot?</span>
        </div>
      </template>
    </van-field>

    <div class="submit-button">
      <van-button block type="primary" native-type="submit">
        {{ submitText }}
      </van-button>
    </div>
  </van-form>
</div>
</template>

<script setup lang="ts">
import { type ILoginPwd, loginByPwd } from '@/api/models/system'
import { showToast } from 'vant'
import { customEventFn, eventName } from '@/plugins/bi-sa.client'
import type { FieldType } from 'vant/es'

const { $sensorsTrack, $SENSORS_EVENT } = useNuxtApp()
interface IProps {
  type?: 'login' | 'binding'
  submitText?: string
  showLogo?: boolean
}
const emits = defineEmits<{
  (event: 'submit', form: ILoginPwd): void
  (event: 'switch:logintype'): void
}>()
const props = withDefaults(
  defineProps<IProps>(),
  {
    type: 'login',
    submitText: 'Login',
    showLogo: false
  }
)
const loginForm = reactive<{ account: string, password: string }>({ password: '', account: '' })
// 当前国家信息
const currentCountry = ref<region.IRegionItem>()
watchEffect(() => {
  // 国家处理
  const countrys: region.IRegionItem[] = useCountrys().value || []
  const cid = useCurrentCountry().value

  // 默认选中的国家ID
  let defaultRId = countrys.find(c => c.isPrimaryDomain) || countrys[0]
  if(cid) {
    defaultRId = countrys.find(c => c.id === Number(cid)) as region.IRegionItem
  }
  currentCountry.value = defaultRId
})

const inputType = ref<FieldType>('password')
const handleShowPassword = () => {
  inputType.value = inputType.value === 'password' ? 'text' : 'password'
}
const { $setUserInfo } = useNuxtApp()
const onSubmit = async() => {
  const params: ILoginPwd = { 
    ...loginForm, 
    regionId: currentCountry.value!.id,
    PfxRegion: currentCountry.value!.id
  }
  
  try {
    const userInfo = await loginByPwd(params)
    
    const LoginMethod = loginForm.account.indexOf('@') >= 0 ? 'email' : 'phone'
    $sensorsTrack($SENSORS_EVENT.LoginSuccess, { LoginMethod })
    await $setUserInfo(userInfo, '', props.type === 'binding')
    customEventFn(eventName.loginSuccess, { login_method: LoginMethod })

    emits('submit', params)
  } catch(e: any) {
    console.error(e)
    showToast(e.msg)
  }
}

const handleToForgotPassword = () => {
  emits('switch:logintype')
}
</script>

<style lang="scss" scoped>
.with-pwd{
  padding: 0 40px;
}
.bind-with-pwd{
  width: 100%;
}
.with-password-form{
  margin-top: 0;
}
.submit-button{
  margin-top: 60px;
  :deep(.van-button--primary) {
    border-radius: 12px;
    font-size: 32px;
    font-weight: 700;
    background: #E04646;
    border-color: #E04646;
  }
}
.logo-img{
  width: 360px;
  min-height: 90px;
}
.password-right{
  display: flex;
  align-items: center;
  gap: 16px;
  cursor: pointer;
}
.password-divider{
  width: 1px;
  height: 28px;
  background: #EAEAEE;
  flex-shrink: 0;
}
.forgot-link{
  color: #4494F0;
  font-size: 26px;
  white-space: nowrap;
}
.region-prefix{
  display: flex;
  align-items: center;
  color: #505050;
  font-size: 28px;
  .region-icon{
    width: 68px;
    height: 43px;
  }
  .prefix{
    padding: 0 10px;
  }
}
</style>
